import { isUrlObject } from '@ui/utils/isUrlObject';
import type { LinkProps as NextLinkProps } from 'next/link';
import { useMemo } from 'react';

import { localeToPath } from './localeToPath';
import { useRouter } from './nextRouterWithLocale';
import { useLocale } from './useLocale';

export const useHrefWithLocale = (
  href: NextLinkProps['href'],
  newLocale?: NextLinkProps['locale'],
) => {
  const router = useRouter();
  const routerLocale = useLocale();
  const locale = newLocale || routerLocale;

  return useMemo(() => {
    const currentHref = href || router.asPath;

    if (!locale) {
      return currentHref;
    }
    if (!currentHref) {
      return router.pathname.replace('[locale]', locale);
    }
    if (isUrlObject(currentHref)) {
      return {
        ...currentHref,
        pathname: `${localeToPath(locale)}${currentHref.pathname}`,
      };
    } else {
      return `${localeToPath(locale)}${currentHref}`;
    }
  }, [href, locale, router.asPath, router.pathname]);
};
